import React from 'react';
import classnames from 'classnames';
import { useTheme } from '../theme';

export type CardHeaderTitleProps = React.HTMLAttributes<HTMLDivElement>;

export const CardHeaderTitle = ({
  className,
  ...props
}: CardHeaderTitleProps): React.ReactElement => {
  const theme = useTheme();
  const classNames = classnames(className, 'airtame-card__header-title');
  return <div className={classNames} data-theme={theme} {...props} />;
};

CardHeaderTitle.displayName = 'CardHeaderTitle';
